import React, { useState, useContext, useEffect, useRef, useMemo, useReducer } from 'react';
import { GoogleMap } from '../../../utils/googlemaps';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros';
import { Modal } from '../../components/modal/Modal';
import { BotonNuevo } from '../../components/buttons/BotonNuevo';
import { SearchTable } from '../../components/utils/SearchTable';
import { notify } from '../../../utils/utils';
import { useModal } from '../../../hooks/useModal';
import { useRegiones } from '../../../hooks/useRegiones';
import { useComisarias } from '../../../hooks/monitoreo/useComisarias'; 
import  iconoComisaria  from '../../../assets/images/IcoUbicacionComisaria04.png'
import { AuthFetch } from '../../../services/api';
import { UserContext } from '../../../context/provider/UserProvider';
import { useEntidades } from '../../../hooks/useEntidades';

var verticesPoligono = [
    { lat: -12.039203, lng: -77.066496 },
    { lat: -12.060808, lng: -77.057635 },
    { lat: -12.061757, lng: -77.027896 },
];

const googleMap = new GoogleMap();

const jurisdiccionDefault = {
    codDepartamento: 0,
    codProvincia: 0,
    codDistrito: 0,
    poligono: null,
    puntosPoligno: '',
    nombre: '',
    codJurisdiccion: 0,
    concatenadoComisarias: ''
}

const urlBasePlamin = process.env.REACT_APP_PLAMIN_API + "/api";

const jurisdiccionTypes = {
    generarPoligono: 'generar-poligono',
    agregarPuntosPoligono: 'agregar-puntos-poligono',
    toggleComisaria: 'toggle-comisaria',
    agregarValoresEdicion: 'agregar-valores-edicion',
    editarValorJurisdiccion: 'editar-valor-jurisdiccion',
    reiniciarJurisdiccion: 'reiniciar-jurisdiccion'
}

const jurisdiccionReducer = (state, action) => {
    switch (action.type) {
        case jurisdiccionTypes.generarPoligono:
            try {
                googleMap.quitarPoligono('nuevo-poligono');
            } catch (err) {

            }

            const nuevoPoligono = googleMap.crearPoligono({
                id: 'nuevo-poligono',
                listLatLng: verticesPoligono,
                editable: true,
                draggable: true,
                color: '#2BA8FF'             
            })
    
            nuevoPoligono.addListener('contextmenu', (e) => {
                action.callaback();
            })
    
            return {
                ...state,
                poligono: nuevoPoligono
            }
        case jurisdiccionTypes.agregarPuntosPoligono: 
            const poligonoActual = action?.payload?.poligono || state.poligono;
            let puntos = '';

            poligonoActual.getPath().forEach(punto => {
                puntos += `${punto.lat()};${punto.lng()},`
            })

            puntos = puntos.substring(0, puntos.length - 1);
            
            return {
                ...state,
                puntosPoligno: puntos
            }        
        case jurisdiccionTypes.toggleComisaria: 
            const { comisaria, checked } = action.payload;
            let concatenado = ''
            if (checked) {
                concatenado = state.concatenadoComisarias + comisaria.codComisaria + ','
            } else {
                concatenado = state?.concatenadoComisarias?.replaceAll(comisaria.codComisaria + ',', '');
            }
            state.nombre=comisaria.nomComisaria
            return {
                ...state,
                concatenadoComisarias: concatenado
            }
        case jurisdiccionTypes.agregarValoresEdicion:
            return {
                ...state,
                ...action.payload
            }
        case jurisdiccionTypes.editarValorJurisdiccion:
            const { key, value } = action.payload;
            return {
                ...state,
                [key] : value
            }
        case jurisdiccionTypes.reiniciarJurisdiccion:
            action?.payload?.quitarPoligono && googleMap.quitarPoligono('nuevo-poligono');

            return {
                ...jurisdiccionDefault,
                poligono: action?.payload?.quitarPoligono ? null : state.poligono
            }
        default:
            throw new Error();
    }
}

const useCatastroComisaria = (comisarias, openModal, obtenerComisariasSinJurisdiccion, openModalComisaria, setComisaria, openModalEliminar, setComisariaEliminar) => {
    const [ , , departamentos, obtenerDepartamentos, provincias, obtenerProvincias, distritos, obtenerDistritos ] = useRegiones();
    const [ state, dispatch ] = useReducer(jurisdiccionReducer, jurisdiccionDefault);

    const listarJurisdicciones = async () => {
        const respuesta = await AuthFetch({
            url: urlBasePlamin + `/Regiones/jurisdicciones`
        });

        if (respuesta.isValid) {
            const jurisdicciones = respuesta.content;
            googleMap.quitarTodosLosPoligonos();

            jurisdicciones.forEach(jurisdiccion => {
                const listLatLng = jurisdiccion.puntosJurisdiccionPoligonoMapa.split(',').map(latLng => {
                    const [ lat, lng ] = latLng.split(';');
                    
                    return {
                        lat: Number(lat), lng: Number(lng)
                    }
                    
                })

                if (!googleMap.poligonos[jurisdiccion.codJurisdiccion]) {
                    const poligono = googleMap.crearPoligono({
                        id: jurisdiccion.codJurisdiccion,
                        listLatLng: listLatLng,
                    })

                    poligono.addListener('dblclick', () => {
                        poligono.setOptions({
                            editable: !poligono.getEditable(),
                            draggable: !poligono.getDraggable()
                        })
                    })

                    poligono.addListener('contextmenu', (e) => {
                        openModal();
                        dispatch({type: jurisdiccionTypes.agregarPuntosPoligono, payload: { poligono }})
                        dispatch({ type: jurisdiccionTypes.agregarValoresEdicion, payload: { 
                            codDepartamento: jurisdiccion.codDepartamento,
                            codProvincia: jurisdiccion.codProvincia,
                            codDistrito: jurisdiccion.codDistrito,
                            // nombre: jurisdiccion.nomComisaria,
                            nombre: jurisdiccion.nomJurisdiccion,
                            codJurisdiccion: jurisdiccion.codJurisdiccion,
                        }})

                        obtenerComisariasSinJurisdiccion(jurisdiccion.comisarias)
                        jurisdiccion.comisarias.forEach(c => {
                            dispatch({ type: jurisdiccionTypes.toggleComisaria, payload: {
                                comisaria: c, 
                                checked: true
                            } })
                        })
                    })
                }
            })
        } else {
            notify(respuesta.content, 'error');
        }
    }

    const guardarJurisdiccion = async (callback) => {
        if (state.nombre.trim().length === 0) {
            notify('Debe ingresar el nombre de la jurisdicción', 'error');
            return state;
        }

        if (state.codDistrito === 0) {
            notify('Debe seleccionar un distrito', 'error');
            return state;
        }

        if (state.concatenadoComisarias.trim().length === 0) {
            notify('Debe seleccionar al menos una comisaria', 'error');
            return state;
        }

        const parametros = {
            codJurisdiccion: state.codJurisdiccion,
            nomJurisdiccion: state.nombre,
            puntosJurisdiccionPoligonoMapa: state.puntosPoligno,
            codDistrito: Number(state.codDistrito),
            codUsuarioAccion: 1,
            concatenadoCodComisaria: state.concatenadoComisarias.substring(0, state.concatenadoComisarias.length - 1)
        }

        state.codJurisdiccion === 0 && (delete parametros['codJurisdiccion'])

        const respuesta = await AuthFetch({
            url: urlBasePlamin + `/Regiones/${state.codJurisdiccion === 0 ? 'generarJurisdiccion' : 'editarJurisdiccion'}`,
            method: state.codJurisdiccion > 0 ? 'PUT' : 'POST',
            body: JSON.stringify(parametros)
        });

        notify(respuesta.content, respuesta.isValid ? 'success' : 'error');

        if (respuesta.isValid) {
            callback();
            dispatch({type: jurisdiccionTypes.reiniciarJurisdiccion, payload: { quitarPoligono: state.codJurisdiccion === 0 }})
            listarJurisdicciones()
        }
    }

    useEffect(()=> {
        googleMap.quitarTodosLosMarcadores();
        const infoWindow = googleMap.crearInfowindow({});
        comisarias.forEach(c => {
            const marcador = googleMap.crearMarcador({
                latLng: { lat: c.latitudComisaria, lng: c.longitudComisaria },
                icon: iconoComisaria,
                animation: null
            })
            marcador.addListener('click', () => {
                infoWindow.setContent(
                    `
                    <div style="width:230px; background:#0f172a; color:white; border-radius:16px; padding:18px; box-shadow:0 8px 20px rgba(0,0,0,.45);">
                        <div style="font-size:15px; font-weight:bold; text-align:center; margin-bottom:18px;">${c.nomComisaria}</div>
                        <div style="display:flex; justify-content:center; gap:12px;">
                            <button
                                id="btn-editar-${c.codComisaria}"
                                style="background:#2563eb; color:white; border:none; padding:10px 18px; border-radius:6px; font-weight:bold; cursor:pointer;"
                            > Editar </button>

                            <button
                                id="btn-eliminar-${c.codComisaria}"
                                style="background:#dc2626; color:white; border:none; padding:10px 18px; border-radius:6px; font-weight:bold; cursor:pointer;"
                            > Eliminar </button>
                        </div>
                    </div>
                    `);
                infoWindow.open({
                    anchor: marcador,
                    map: googleMap.map
                })
                
                setTimeout(() => {
                    const btnEditar = document.getElementById(`btn-editar-${c.codComisaria}`)
                    const btnEliminar = document.getElementById(`btn-eliminar-${c.codComisaria}`)

                    if ( btnEditar) {
                        btnEditar.onclick = () => {
                            infoWindow.close()
                            setComisaria({
                                codComisaria: c.codComisaria,
                                nomComisaria: c.nomComisaria,
                                latitud: c.latitudComisaria,
                                longitud: c.longitudComisaria,
                                telefonoFijoUno: c.telefonoFijoUno || '',
                                telefonoFijoDos: c.telefonoFijoDos || '',
                                telefonoFijoTres: c.telefonoFijoTres || '',
                                celular: c.celular || '',
                                direccion: c.direccion || '',
                                comisario: c.comisario || ''
                            })
                            openModalComisaria()
                        }
                    }

                    if (  btnEliminar) {
                        btnEliminar.onclick = async () => {
                            setComisariaEliminar(c)
                            openModalEliminar()
                            infoWindow.close()
                        }
                    }
                }, 100);

            })
        })
    }, [comisarias]);

    useMemo(() => {
        obtenerDepartamentos();
    }, [])

    useMemo(() => {
        obtenerProvincias(Number(state.codDepartamento))
    }, [state.codDepartamento])

    useMemo(() => {
        obtenerDistritos(Number(state.codProvincia))
    }, [state.codProvincia])

    return {
        state,
        dispatch,
        listarJurisdicciones,
        guardarJurisdiccion,
        departamentos,
        provincias,
        distritos
    }
}

export const CatastroComisaria= () => {

    const [ isOpen, openModal, closeModal ] = useModal();
    const { comisarias, comisariasJurisdiccion, obtenerComisariasSinJurisdiccion, obtenerComisarias} = useComisarias();
    const [ isOpenComisaria, openModalComisaria, closeModalComisaria ] = useModal();
    const [isOpenEliminar, openModalEliminar, closeModalEliminar] = useModal();
    const [comisariaEliminar, setComisariaEliminar] = useState(null);
    const {
        guardarComisaria,
        comisaria,
        setComisaria,
        comisariaDefault,
        eliminarComisaria,
    } = useEntidades()
    const { state, dispatch, listarJurisdicciones, guardarJurisdiccion, departamentos, provincias, distritos } = useCatastroComisaria(comisarias, openModal, obtenerComisariasSinJurisdiccion, openModalComisaria, setComisaria, openModalEliminar, setComisariaEliminar);
    const { stateUser } = useContext(UserContext)
    const [isSelectingLocation, setIsSelectingLocation] = useState(false);
    const tempMarkerRef = useRef(null);
    const [verJurisdiccionesMapa, setVerJurisdiccionesMapa] = useState(false);
    const [jurisdiccionesAlertasCargadas, setJurisdiccionesAlertasCargadas] = useState([]);
    const [estaCargandoJurisdicciones, setEstaCargandoJurisdicciones] = useState(false);
    const poligonosJurisdiccionAlertaRef = useRef([]);

    const mapDiv = useRef();

    const idTablaComisarias = "tabla-comisarias";    
    const classNameInput = "containerScroll  text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"   
    const classNameSelect = "containerScroll  text-white h-full rounded px-4 w-[250px] lg:w-[200px] bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"


    useEffect(() => {
        googleMap.inicializarMapa(mapDiv.current, { zoom: 11 });
    }, [])

    useEffect(() => {
        obtenerComisariasSinJurisdiccion();
        listarJurisdicciones();
        obtenerComisarias()
    }, [])

    const elegirCoordenadasEnMapa = async () => {
        closeModalComisaria()
        setIsSelectingLocation(true)

        const initialPos = {
            lat: parseFloat(comisaria.latitud) || -12.046374,
            lng: parseFloat(comisaria.longitud) || -77.042793
        }

        tempMarkerRef.current = googleMap.crearMarcador({
            latLng: initialPos,
            draggable: true,
            animation: true,
            icon: null
        })

        googleMap.map.setCenter(initialPos)
        googleMap.map.setZoom(14)

    };

    const confirmarUbicacionMapa = () => {
        if (tempMarkerRef.current) {
            const position = tempMarkerRef.current.getPosition();
            setComisaria(prev => ({
                ...prev,
                latitud: position.lat().toFixed(9),
                longitud: position.lng().toFixed(9)
            }));
            googleMap.quitarMarcadorEspecifico(tempMarkerRef.current);
            tempMarkerRef.current = null;
        }
        setIsSelectingLocation(false);
        openModalComisaria();
    };

    const cancelarSeleccionMapa = () => {
        if (tempMarkerRef.current) {
            googleMap.quitarMarcadorEspecifico(tempMarkerRef.current);
            tempMarkerRef.current = null;
        }
        setIsSelectingLocation(false);
        openModalComisaria();
    };

    const parsearMultiPolygonWKT = (wktString) => {
        if (!wktString) return [];
        const polygonMatch = wktString.match(/\([^()]*\)/g);
        if (!polygonMatch) return [];

        return polygonMatch.map(polyStr => {
            const coordenadas = polyStr.replace(/[()]/g, '').trim().split(',');
            return coordenadas.map(coord => {
                const [lng, lat] = coord.trim().split(/\s+/);
                return { lat: Number(lat), lng: Number(lng) };
            });
        });
    };

    const limpiarPoligonosJurisdiccionAlertas = () => {
        poligonosJurisdiccionAlertaRef.current.forEach(poligono => {
            if (poligono) poligono.setMap(null);
        });
        poligonosJurisdiccionAlertaRef.current = [];
    };

    const dibujarPoligonosJurisdiccionAlertas = (jurisdicciones) => {
        limpiarPoligonosJurisdiccionAlertas();
        const nuevasInstancias = [];

        jurisdicciones.forEach(jurisdiccion => {
            const arreglosCoordenadas = parsearMultiPolygonWKT(jurisdiccion.lineasPoligonales);
            arreglosCoordenadas.forEach(path => {
                const poligono = new window.google.maps.Polygon({
                    paths: path,
                    strokeColor: jurisdiccion.color || "#0000FF",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: jurisdiccion.color || "#0000FF",
                    fillOpacity: 0.2,
                    map: googleMap.map
                });

                poligono.addListener("click", (e) => {
                    const infoWindow = new window.google.maps.InfoWindow({
                        content: `<div class="p-2 font-bold text-black">${jurisdiccion.comisaria}</div>`,
                        position: e.latLng
                    });
                    infoWindow.open(googleMap.map);
                });

                nuevasInstancias.push(poligono);
            });
        });

        poligonosJurisdiccionAlertaRef.current = nuevasInstancias;
    };

    useEffect(() => {
        const fetchJurisdicciones = async () => {
            try {
                const response = await AuthFetch({
                    url: urlBasePlamin + '/Entities/jurisdictionsAlerts'
                });
                if (response.isValid) {
                    setJurisdiccionesAlertasCargadas(response.content);
                } else {
                    notify("No se pudo cargar las áreas de jurisdicción", "error");
                    setEstaCargandoJurisdicciones(false);
                }
            } catch (error) {
                console.error("Error al cargar jurisdicciones:", error);
                notify("No se pudo cargar las áreas de jurisdicción", "error");
                setEstaCargandoJurisdicciones(false);
            }
        };

        if (verJurisdiccionesMapa) {
            if (jurisdiccionesAlertasCargadas.length === 0) {
                setEstaCargandoJurisdicciones(true);
                fetchJurisdicciones();
            }
        } else {
            limpiarPoligonosJurisdiccionAlertas();
        }
    }, [verJurisdiccionesMapa]);

    useEffect(() => {
        if (verJurisdiccionesMapa && jurisdiccionesAlertasCargadas.length > 0 && googleMap.map) {
            dibujarPoligonosJurisdiccionAlertas(jurisdiccionesAlertasCargadas);
            setEstaCargandoJurisdicciones(false);
        }
    }, [verJurisdiccionesMapa, jurisdiccionesAlertasCargadas]);

    
    return (
        <>
            <ContenedorParametros
                titulo="Entidades"
            >
                {
                    stateUser.permisos.find(p => p.nomPermiso === 'Generar Poligono') && (
                        <div>
                            <BotonNuevo onClick={() => dispatch({type: jurisdiccionTypes.generarPoligono, callaback: () => {
                                openModal();
                                dispatch({type: jurisdiccionTypes.agregarPuntosPoligono})
                            }})}>Generar Poligono</BotonNuevo>
                        </div>
                    )
                }

                <div className="flex items-center gap-3">
                    <BotonNuevo onClick={openModalComisaria}> Nueva Comisaría </BotonNuevo>
                    
                    <button
                        onClick={() => setVerJurisdiccionesMapa(!verJurisdiccionesMapa)}
                        className={`px-4 h-[35px] rounded text-xs font-bold transition-all flex items-center justify-center gap-2 border shadow-sm ${
                            verJurisdiccionesMapa 
                            ? 'bg-blue-600 text-white border-blue-700' 
                            : 'bg-zinc-800 text-gray-300 hover:bg-zinc-700 border-zinc-600'
                        }`}
                    >
                        <i className="fas fa-draw-polygon text-[14px]" /> 
                        {verJurisdiccionesMapa ? 'Ocultar Jurisdicciones' : 'Ver Jurisdicciones'}
                        {estaCargandoJurisdicciones && <i className="fas fa-spinner fa-spin ml-1"></i>}
                    </button>
                </div>
            </ContenedorParametros>
            <div className="mapa-incidentes h-[90%]">
                <div className='w-full h-full' ref={mapDiv}></div>
            </div>

            <Modal
                isOpen={isOpen}
                closeModal={() => {
                    closeModal();
                    obtenerComisariasSinJurisdiccion();
                    dispatch({type: jurisdiccionTypes.reiniciarJurisdiccion})
                }}
                cerrarAlGuardar={false}
                title={"Registrar Poligono"}
                action={() => guardarJurisdiccion(() => {
                    obtenerComisariasSinJurisdiccion();
                    listarJurisdicciones();
                    closeModal();
                })}
                >
                <div className="w-[500px] px-4 flex-col">
                    <div className="flex flex-col justify-between w-full form-content">
                        <div>
                            <label>Nombre Jurisdicción: </label>
                            <div className="flex items-center gap-4 w-[250px]">
                                <input defaultValue={state.nombre} onChange={(e) => dispatch({type: jurisdiccionTypes.editarValorJurisdiccion, payload: {key: 'nombre', value: e.target.value}})} className={`${classNameInput}`} />
                            </div>
                        </div>
                        <div>
                            <label>Departamento: </label>
                            <div className="flex items-center gap-4 w-[250px]">
                                <select className={`${classNameInput}`} value={state.codDepartamento} onChange={(e) => dispatch({type: jurisdiccionTypes.editarValorJurisdiccion, payload: {key: 'codDepartamento', value: e.target.value}})}>
                                    <option value="0">-- Seleccionar --</option>
                                    {
                                        departamentos.map(d => {
                                            return <option key={d.codDepartamento} value={d.codDepartamento}>{d.nomDepartamento}</option>
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div>
                            {/* onChange={e => obtenerDistritos(e.target.value)}  */}
                            <label>Provincia: </label>
                            <div className="flex items-center gap-4 w-[250px]">
                                <select className={`${classNameInput}`} value={state.codProvincia} onChange={(e) => dispatch({type: jurisdiccionTypes.editarValorJurisdiccion, payload: {key: 'codProvincia', value: e.target.value}})}>
                                    <option value="0">-- Seleccionar --</option>
                                    {
                                        provincias.map(p => {
                                            return <option key={p.codProvincia} value={p.codProvincia}>{p.nomProvincia}</option>
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div>
                            <label>Distrito: </label>
                            <div className="flex items-center gap-4 w-[250px]">
                                <select className={`${classNameInput}`} value={state.codDistrito} onChange={(e) => dispatch({type: jurisdiccionTypes.editarValorJurisdiccion, payload: {key: 'codDistrito', value: e.target.value}})}>
                                    <option value="0">-- Seleccionar --</option>
                                    {
                                        distritos.map(d => {
                                            return <option key={d.codDistrito} value={d.codDistrito}>{d.nomDistrito}</option>
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="h-[40px]">
                        <SearchTable tablaId={idTablaComisarias}></SearchTable>
                    </div>
                    <div className="containerScroll max-h-[200px] overflow-auto">
                        <table id={idTablaComisarias} className="table">
                            <thead>
                                <tr>
                                    <th>N</th>
                                    <th>COMISARIA</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    comisariasJurisdiccion.map((c, i) => {
                                        return (
                                            <tr key={ c.codComisaria }>
                                                <td>{ i + 1 }</td>
                                                <td>{ c.nomComisaria }</td>
                                                <td></td>
                                                <td>
                                                    <input type="checkbox" defaultChecked={c.checked} onChange={(e) => dispatch({type: jurisdiccionTypes.toggleComisaria, payload: {
                                                        comisaria: c,
                                                        checked: e.target.checked
                                                    }})}></input>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>

            <Modal
                isOpen={isOpenComisaria}
                closeModal={() => {
                    closeModalComisaria();
                    setComisaria(comisariaDefault);
                    if (tempMarkerRef.current) googleMap.quitarMarcadorEspecifico(tempMarkerRef.current);
                }}
                title={Number(comisaria.codComisaria) > 0 ? "Editar Comisaría" : "Registrar Comisaría"}
                action={async () => {
                    const response = await guardarComisaria();
                    if (response) {
                        await obtenerComisarias();
                        closeModalComisaria();
                        setComisaria(comisariaDefault)
                    }
                }}
            >
                <div className="w-full max-w-[500px] px-4 py-2 flex flex-col gap-2">

                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-bold text-gray-300">Nombre Comisaría</label>
                        <input
                            className={classNameInput}
                            value={comisaria.nomComisaria}
                            onChange={(e) => setComisaria({...comisaria, nomComisaria: e.target.value})}
                        />
                    </div>

                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-bold text-gray-300">Dirección</label>
                        <input
                            className={classNameInput}
                            value={comisaria.direccion || ''}
                            onChange={(e) => setComisaria({...comisaria, direccion: e.target.value})}
                        />
                    </div>

                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-bold text-gray-300">Comisario</label>
                        <input
                            className={classNameInput}
                            value={comisaria.comisario || ''}
                            onChange={(e) => setComisaria({...comisaria, comisario: e.target.value})}
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-4 mt-1">
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-bold text-gray-300">Teléfono 1</label>
                            <input
                                type="text"
                                inputMode="numeric"
                                maxLength={7}
                                className={classNameInput}
                                value={comisaria.telefonoFijoUno || ''}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, '');
                                    setComisaria({...comisaria, telefonoFijoUno: val})
                                }}
                            />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-bold text-gray-300">Teléfono 2</label>
                            <input
                                type="text"
                                inputMode="numeric"
                                maxLength={7}
                                className={classNameInput}
                                value={comisaria.telefonoFijoDos || ''}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, '')
                                    setComisaria({...comisaria, telefonoFijoDos: val})
                                }}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-bold text-gray-300">Teléfono 3</label>
                            <input
                                type="text"
                                inputMode="numeric"
                                maxLength={7}
                                className={classNameInput}
                                value={comisaria.telefonoFijoTres || ''}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, '');
                                    setComisaria({...comisaria, telefonoFijoTres: val})
                                }}
                            />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label className="text-xs font-bold text-gray-300">Celular</label>
                            <input
                                type="text"
                                inputMode="numeric"
                                maxLength={9}
                                className={classNameInput}
                                value={comisaria.celular || ''}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, '')
                                    setComisaria({...comisaria, celular: val})
                                }}
                            />
                        </div>
                    </div>

                    <div className="p-3 rounded border border-zinc-700 bg-zinc-900/50 flex flex-col gap-2 mt-1">
                        <button 
                            type="button"
                            onClick={elegirCoordenadasEnMapa}
                            className="w-full bg-blue-700 hover:bg-blue-600 text-white font-semibold py-2 rounded text-xs transition-all flex items-center justify-center gap-2"
                        >
                            <i className="fa fa-map-marker" /> ELEGIR COORDENADAS EN EL MAPA
                        </button>

                        <div className="grid grid-cols-2 gap-4">
                            <div className="flex flex-col gap-1">
                                <label className="text-xs text-gray-400">Latitud</label>
                                <input
                                    type="number"
                                    step="any"
                                    className={classNameInput}
                                    value={comisaria.latitud}
                                    onChange={(e) => setComisaria({...comisaria, latitud: e.target.value})}
                                />
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="text-xs text-gray-400">Longitud</label>
                                <input
                                    type="number"
                                    step="any"
                                    className={classNameInput}
                                    value={comisaria.longitud}
                                    onChange={(e) => setComisaria({...comisaria, longitud: e.target.value})}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                isOpen={isOpenEliminar}
                closeModal={closeModalEliminar}
                title={"Eliminar Comisaría"}
                textButtons={{
                    confirm: 'Eliminar',
                    denied: 'Cerrar'
                }}
                action={async () => {
                    const eliminado = await eliminarComisaria( comisariaEliminar.codComisaria )
                    if (eliminado) {
                        closeModalEliminar()
                        obtenerComisarias()
                    }
                }}
            >

                <div className="w-[350px] py-6 px-4 text-center">
                    <div className="text-red-500 text-5xl mb-4"><i className="fa fa-trash" /></div>
                    <div className="text-white text-lg font-bold mb-3">¿Está seguro que desea eliminar la comisaría?</div>
                    <div className="text-gray-300">{comisariaEliminar?.nomComisaria}</div>
                </div>

            </Modal>

            {isSelectingLocation && (
                <div className="fixed bottom-0.5 left-1/2 -translate-x-1/2 z-[2000] flex gap-4 bg-white/20 backdrop-blur-md p-4 rounded-xl shadow-2xl border border-white/30">
                    <button 
                        onClick={confirmarUbicacionMapa}
                        className="bg-blue-600 hover:bg-blue-500 text-white px-6 py-2 rounded-lg font-bold flex items-center gap-2 transition-all"
                    >
                        <i className="fa fa-check" /> Confirmar ubicación
                    </button>
                    <button 
                        onClick={cancelarSeleccionMapa}
                        className="bg-red-600 hover:bg-red-500 text-white px-6 py-2 rounded-lg font-bold flex items-center gap-2 transition-all"
                    >
                        <i className="fa fa-times" /> Cancelar selección
                    </button>
                </div>
            )}
        </>
    )
}